import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import TrainingDataApi from './TrainingDataApi';
import ModelLink from '@dex/bubl-dash/src/lib/components/ModelLink/ModelLink';

let settings;

export default settings = {
    key: 'training/data',
    zone: 'training',
    path: '/training/data',
    title: "Training Data",
    endpoint: TrainingDataApi.endpoint,
    modelName: 'TrainingData',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewTrainingData"],
    viewCaps: ["viewTrainingData"],
    createCaps: ["createTrainingData"],
    updateCaps: ["updateTrainingData"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: TrainingDataApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ["user", "program"], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['data', 'slug'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "User",
                key: "userId",
                type: "relationship",
                model: "Users",
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "",
                key: "this",
                render: (value, data) => {
                    return <ModelLink modelName="TrainingData" data={{ id: data.id, title: "View Data" }} />
                }
            },
            {
                label: "Label",
                key: "dataLabel",
            },
            {
                label: "Type",
                key: "dataType",
                format: "titleCase",
            },
            {
                label: "Value",
                key: "dataValue",
            },
            {
                label: "User",
                key: "user",
                format: "ModelLink",
            },
            {
                label: "Program",
                key: "program",
                format: "ModelLink",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: TrainingDataApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: TrainingDataApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ["user", "program"] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};